import { Anchor, Breadcrumbs, Grid, Text } from '@mantine/core';
import { useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router';
import ErrorMessage from '../../components/ErrorMessage';
import Metadata from '../../components/Metadata';
import Spinner from '../../components/Spinner';
import SurveyForm from '../../components/Surveys/SurveyForm';
import { Page } from '../../constants/pageTitles';
import useFetch from '../../helpers/useFetch';

const page = `${Page['survey']}`;

const SurveysDetailsPage = () => {
  const fetch = useFetch();
  const navigate = useNavigate();

  const [survey, setSurvey] = useState();
  const [userError, setUserError] = useState();
  const [loadError, setLoadError] = useState();
  const [loading, setLoading] = useState(false);
  const { accountId, domainId, surveyId } = useParams();

  useEffect(() => {
    fetch(`/api/admin/accounts/${accountId}/domains/${domainId}/surveys/${surveyId}`)
      .then(({ survey }) => setSurvey(survey))
      .catch(setLoadError);
  }, [accountId, domainId, fetch, surveyId]);

  const update = (survey) => {
    setLoading(true);
    fetch(`/api/admin/accounts/${accountId}/domains/${domainId}/surveys/${surveyId}`, {
      method: 'PUT',
      body: JSON.stringify(survey),
    })
      .then(() => {
        navigate(`/accounts/${accountId}/domains/${domainId}/surveys`);
      })
      .catch(setUserError)
      .finally(() => setLoading(false));
  };

  const del = (cb) => {
    fetch(`/api/admin/accounts/${accountId}/domains/${domainId}/surveys/${survey.id}`, {
      method: 'DELETE',
    })
      .then(() => {
        if (typeof cb === 'function') {
          cb();
        }
        navigate(`/accounts/${accountId}/domains/${domainId}/surveys`);
      })
      .catch(setLoadError);
  };

  if (loadError) {
    return <ErrorMessage message={loadError.message} />;
  }

  if (survey === undefined) {
    return <Spinner />;
  }

  const breadcrumbItems = [
    { title: 'Home', href: `#/accounts/${accountId}/domains/${domainId}/analytics` },
    { title: page, href: `#/accounts/${accountId}/domains/${domainId}/surveys` },
    {
      title: survey?.name || 'Unknown Survey',
      href: `#/accounts/${accountId}/domains/${domainId}/surveys/${survey?.id}/analytics`,
    },
    { title: 'Edit' },
  ].map((item, index) =>
    item.href ? (
      <Anchor href={item.href} key={index}>
        {item.title}
      </Anchor>
    ) : (
      <Text key={index}>{item.title}</Text>
    )
  );

  return (
    <>
      <Metadata title={`${page} | ${survey?.name || 'Unknown survey'} | Edit`} />
      <Breadcrumbs mb="md">{breadcrumbItems}</Breadcrumbs>

      <Grid>
        <Grid.Col span={12}>
          <SurveyForm
            loading={loading}
            survey={survey}
            saveSurvey={(survey) => update(survey)}
            cancel={() => navigate(`/accounts/${accountId}/domains/${domainId}/surveys`)}
            deleteSurvey={(cb) => del(cb)}
          />
        </Grid.Col>
      </Grid>
      {userError ? (
        <div style={{ textAlign: 'right' }}>
          <ErrorMessage message={userError.message} />
        </div>
      ) : null}
    </>
  );
};

export default SurveysDetailsPage;
